import React from 'react';

export default function PrivacyPolicy() {
    return (
        <main className="container mx-auto p-6 prose">
            <h1>Aviso de Privacidad</h1>
            <p><strong>Inspira Cambio A.C.</strong> ("Inspira"), domicilada en Insurgentes Centro 56 Int. 401 y 402, Col. Tabacalera, CDMX, C.P. 06030, es responsable del uso y protección de sus datos personales.</p>

            <h2>Datos Recabados y Finalidades</h2>
            <ul>
                <li><strong>Datos de identificación y contacto:</strong> Registro de visitas y seguimiento de servicios.</li>
                <li><strong>Datos sensibles:</strong> Estado de salud físico y mental, preferencias y prácticas sexuales, para informes estadísticos.</li>
            </ul>

            <h2>Transferencias y Compartición</h2>
            <p>Sus datos pueden compartirse con el Programa de VIH/Sida de CDMX para referencia médica oportuna, con su consentimiento.</p>

            <h2>Derechos ARCO</h2>
            <p>Usted puede Acceder, Rectificar, Cancelar u Oponerse al uso de sus datos (ARCO) presentando solicitud dirigida a la Gerencia de Programas en Insurgentes Centro 51 Int. 601, San Rafael, CDMX, o vía correo a <a href="mailto:info@inspiracambio.org">info@inspiracambio.org</a>. Respuesta en 30 días naturales.</p>

            <h2>Revocación de Consentimiento</h2>
            <p>Puede revocar su consentimiento mediante solicitud escrita dirigida a la Gerencia de Programas. Respuesta en 30 días naturales.</p>

            <h2>Limitación de Uso y Divulgación</h2>
            <p>Para limitar el uso o divulgación, comuníquese a 55 5566 1528 / 5566 7250 o <a href="mailto:info@inspiracambio.org">info@inspiracambio.org</a>.</p>

            <h2>Actualizaciones al Aviso</h2>
            <p>Este aviso puede modificarse por razones legales o de negocio. Se notificará mediante anuncios en instalaciones, sitio web y redes sociales.</p>

            <h2>Consentimiento</h2>
            <p>Su registro implica la firma de consentimiento para el tratamiento de datos conforme a este aviso.</p>
        </main>
    );
}
